import { useState } from "react";

const useAlertFormValidator = (formData, isObjectAlert = false) => {
	const [errors, setErrors] = useState({
		name: "",
		keywords: [],
	});

	const validateForm = () => {
		const newErrors = {};
		let formIsValid = true;

		if (!formData.name.trim()) {
			newErrors.name = "Un nom pour l'alerte est requis.";
			formIsValid = false;
		}

		if (!isObjectAlert && formData.keywords.length === 0) {
			newErrors.keywords = "Au moins un mot-clé doit être défini.";
			formIsValid = false;
		}

		if (formData.sources.length === 0) {
			newErrors.sources = "Au moins une source doit être définie.";
			formIsValid = false;
		}

		setErrors(newErrors);
		return formIsValid;
	};

	return { errors, validateForm };
};

export default useAlertFormValidator;
